export { default as ToggleGroupControlOption } from './component';